"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// import tokens from '@/tokens/tokens-kov.json';
// import contracts from '@/contracts/contract-abi-kov.json';
// import kov from '@/assets/images/icons/network.svg';
var _default = {
  name: 'KOV',
  name_long: 'Kovan',
  homePage: 'https://kovan-testnet.github.io/website/',
  blockExplorerTX: 'https://kovan.etherscan.io/tx/[[txHash]]',
  blockExplorerAddr: 'https://kovan.etherscan.io/address/[[address]]',
  chainID: 42,
  tokens: [],
  contracts: [],
  // icon: kov,
  currencyName: 'KOV'
};
exports.default = _default;